import { useEffect } from "react";

// TEMPORARY: AU Bank is hardcoded here for now (not CMS-driven). Confirmed
// final color: #f9c7a4. If other integrators need a custom background later,
// replace this with a real per-integrator CMS field (matching how fonts work
// in useIntegratorFonts.js) instead of growing this subdomain list.
const AU_BANK_SUBDOMAINS = ["au"];

const BG_COLOR = "#ededf2";

// Known top-level page-wrapper classNames this needs to paint over — add to
// this list if a new page's root wrapper isn't picking up the override.
const PAGE_WRAPPER_SELECTORS = [
  "body",
  ".homePageWrapper",
  ".contactUsWrapper",
  ".preciousMetalsWrapper",
  ".privacyPolicyWrapper",
  ".rewardListingWrapper",
  ".showOffWhiteBg",
  ".rewardSectionWrapper",
  ".popularCategoryWrapper",
  ".whatsNewSectionWrapper",
  ".travelSectionWrapper",
  ".popularRetailerWrapper",
  ".subscriptionSectionWrapper",
  ".midBannerWrapper",
  ".mainFooter",
  ".subFooter",
  ".headerContainer",
  ".headerContainer",
  ".showOffWhiteBackgroundColor",
  ".rewardListingWrapper",
  ".heroSectionWrapper",
  ".rewardDetailPageWrapper",
  ".userProfileWrapper",
  ".bannerCarouselWrapper",
  ".mainLayout",
  // ".sidebarSection",
  ".orderview"
];

const STYLE_ID = "au-bank-bg-override";

export const useAuBankBackground = (subDomain) => {
  useEffect(() => {
    const isAuBank = AU_BANK_SUBDOMAINS.includes(subDomain);
    const existingStyle = document.getElementById(STYLE_ID);

    if (!isAuBank) {
      existingStyle?.remove();
      return;
    }

    const style = existingStyle || document.createElement("style");
    style.id = STYLE_ID;
    style.textContent = `${PAGE_WRAPPER_SELECTORS.join(", ")} { background-color: ${BG_COLOR} !important; }`;
    if (!existingStyle) document.head.appendChild(style);

    return () => {
      document.getElementById(STYLE_ID)?.remove();
    };
  }, [subDomain]);
};
